import {Viewer} from 'bigdatr-style';
import {AU, SupportedCountry} from 'bigdatr-style';

export default function shouldOnboardUser(viewer: Viewer, currentCountry: SupportedCountry) {
    const isOnTrial = viewer.isCountryOnTrial(currentCountry);
    // first user hasn't changed the team name yet
    const hasTrialTeamName = viewer.currentTeam.hasTrialTeamName === true;

    // aussie logic
    if (currentCountry === AU) {
        return (
            // these checks are related to the first user on a new automated trial
            (isOnTrial && hasTrialTeamName) ||
            // this is specific to every user in an aussie team
            viewer.userOnboardingInfo.isAustraliaOnboarded === false
        );
    }

    // non aussie logic, only related to the first user on a new automated trial
    if (isOnTrial && hasTrialTeamName) {
        return true;
    }

    // team and user is onboarded
    return false;
}
